import React from 'react';
import { connect } from 'react-redux';

import './styles.scss';
import { IAppState } from 'src/store';
import { IMAGES } from 'src/appConfig/images';
import { Image, View } from 'src/components/common';

const SplashScreen: React.FC<Props> = () => {
  return (
    <View className="cmp-splash-screen">
      <Image src={IMAGES.logoRalph} className="cmp-splash-screen__image" />
    </View>
  );
};

type Props = ReturnType<typeof mapStateToProps> & typeof mapDispatchToProps;
const mapStateToProps = (state: IAppState) => ({});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(SplashScreen);
